import React from 'react';

/**
 * ModalBackdrop Component
 * Transparent container positioned at top of screen
 */
const ModalBackdrop = ({ isVisible, children }) => {
  if (!isVisible) return null;

  return (
    <div
      className="walkthrough-modal-backdrop"
      role="presentation"
      aria-hidden="true"
    >
      {children}
    </div>
  );
};

export default ModalBackdrop;
